
import {staAppid } from './config'
/**
 * 获取uuid
 * 如：1624819897644-1389918-0ed8161319cedb-22991203
 * Math.random().toString(16).replace('.', '')：0～1的随机数以十六进制显示，并去掉小数点，如：0.f03fb618bf531，并去掉小数点
 * @zjf-2021-06-27
 */
export function getUUID () {
	return "" + Date.now() + '-' + Math.floor(1e7 * Math.random()) + '-' + Math.random().toString(16).replace('.', '') +
		'-' + String(Math.random() * 31242).replace('.', '').slice(0, 8);
}

export async function initDrgStatics(){
	
	window.collectEvent('init', {
		//app_id:20005236, // 参考2.1节获取，注意类型是number而非字符串
		//app_id:20007138,
		app_id:staAppid,
		channel_domain: 'https://gator.volces.com', // 设置数据上送地址
		log:true, // true:开启日志，false:关闭日志
    	autotrack:true, // 全埋点开关，true开启，false关闭
	});

	// var uuid= localStorage.getItem('uuid')
	// if(!uuid){
	// 	uuid=getUUID()
	// 	localStorage.setItem('uuid',uuid)
	// }
	// window.collectEvent('config', { 
	// 	user_unique_id: uuid  //设置唯一用户ID 
	//  });

	 
	// 此处可添加设置uuid、设置公共属性等代码
	window.collectEvent('start'); // 通知SDK设置完毕，可以真正开始发送事件了
}

/** 
 * 设置uuid
 * @params memberId  账号id；
 * 登录后调用  值为账号id
 * 登出后调用  值为""
 * 
 */
export async function setUserUniqueId(memberId){
	if(memberId){
		window.collectEvent('config', {
			user_unique_id: memberId  //设置唯一用户ID 
		 });
	}else{
		window.collectEvent('config', {
		    user_unique_id: null 
		});
	}
}

/** 
 * 统计事件
 * @params eventData Object 参数 
 * @params eventName 事件名称
 */
export function drgStatEvent(eventName,eventData){	
	if(window.collectEvent){
		window.collectEvent(eventName, { 
			...eventData
		 });
	}
	
}